"use client"

import { useFrontendPreferences } from "@lib/frontend-preferences"

const RelatedProductsHeading = () => {
  const { locale, t } = useFrontendPreferences()

  return (
    <div className="flex flex-col items-center text-center mb-16" dir={locale === "fa" ? "rtl" : "ltr"}>
      <span className="text-base-regular text-gray-600 mb-6">
        {t.product.relatedProducts}
      </span>
      <p className="text-2xl-regular text-ui-fg-base max-w-lg">
        {t.product.relatedProductsBody}
      </p>
    </div>
  )
}

export default RelatedProductsHeading
